import { queryKeys } from '@/lib/query-keys';
import { orgMembersClient } from '@/lib/api/ts-rest';
import { useQuery } from '@tanstack/react-query';

export function useMemberAllowedSites({
  organizationId,
  userId,
}: {
  organizationId?: string;
  userId?: string;
}) {
  return useQuery<string[]>({
    queryKey: queryKeys.organizations.memberAllowedSites(organizationId, userId),
    queryFn: async () => {
      const res = await orgMembersClient.getMemberAllowedSites({
        params: { organizationId: organizationId!, memberId: userId! },
      });
      if (res.status !== 200) throw new Error('Failed to load allowed sites');
      return res.body;
    },
    enabled: !!organizationId && !!userId,
  });
}
